(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["announcement-bar"]) return;
  try {
    
  (() => {
    const bindBannerControls = () => {
      document.querySelectorAll('.announcement-bar-section [data-mobile-autoplay]').forEach((banner) => {
        if (banner.dataset.controlsBound) return;
        banner.dataset.controlsBound = 'true';
        let hideControls;
        banner.addEventListener('click', () => {
          window.clearTimeout(hideControls);
          banner.classList.add('cs-controls-visible');
          hideControls = window.setTimeout(() => banner.classList.remove('cs-controls-visible'), 4000);
        });
      });
    };
    bindBannerControls();
    document.addEventListener('shopify:section:load', bindBannerControls);
    const countdownWindow = 72 * 60 * 60 * 1000;
    const localPreview = ['localhost', '127.0.0.1', '[::1]'].includes(window.location.hostname)
      && new URLSearchParams(window.location.search).get('banner_countdown') === 'preview';
    const previewEnd = Date.now() + countdownWindow - 1000;
    let countdownTimer;
    const updateCountdown = () => {
      window.clearTimeout(countdownTimer);
      let delay = Infinity;
      document.querySelectorAll('[data-hw-banner][data-hw-ends-at]').forEach((banner) => {
        const end = localPreview ? previewEnd : Number(banner.dataset.hwEndsAt);
        const time = banner.querySelector('[data-hw-time]');
        if (!Number.isFinite(end) || !time) return;
        const remaining = end - Date.now();
        if (remaining <= 0) { banner.hidden = true; return; }
        banner.hidden = false;
        if (remaining > countdownWindow) {
          if (time.textContent !== 'Ends Soon') time.textContent = 'Ends Soon';
          delay = Math.min(delay, remaining - countdownWindow);
          return;
        }
        const seconds = Math.ceil(remaining / 1000);
        const hours = Math.floor(seconds / 3600);
        const minutes = String(Math.floor(seconds % 3600 / 60)).padStart(2, '0');
        const secs = String(seconds % 60).padStart(2, '0');
        const value = `Ends in ${hours}h ${minutes}m ${secs}s`;
        if (time.textContent !== value) time.textContent = value;
        delay = Math.min(delay, 1000);
      });
      if (!document.hidden && Number.isFinite(delay)) countdownTimer = window.setTimeout(updateCountdown, Math.min(delay, 2147483647));
    };
    updateCountdown();
    window.addEventListener('pageshow', updateCountdown);
    document.addEventListener('visibilitychange', updateCountdown);
    document.addEventListener('shopify:section:load', updateCountdown);
    const updateBanners = (country) => {
      if (!/^[A-Z]{2}$/.test(country || '')) return;
      document.querySelectorAll('[data-uk-delivery-banner]').forEach((banner) => {
        banner.hidden = country === 'GB';
      });
    };
    fetch(`${window.Shopify?.routes?.root || '/'}browsing_context_suggestions.json?country[enabled]=true`, {
      headers: { Accept: 'application/json' }
    })
      .then((response) => response.ok ? response.json() : null)
      .then((data) => updateBanners(data?.detected_values?.country?.handle))
      .catch(() => {});
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["home-mat-showcase"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('click', (event) => {
    const toggle = event.target.closest('.mat-showcase__toggle');
    if (!toggle) return;
    const card = toggle.closest('.mat-showcase__card');
    const showLifestyle = toggle.getAttribute('aria-pressed') !== 'true';
    card.classList.toggle('is-lifestyle', showLifestyle);
    toggle.setAttribute('aria-pressed', String(showLifestyle));
    toggle.setAttribute('aria-label', showLifestyle ? toggle.dataset.productLabel : toggle.dataset.lifestyleLabel);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["yogaspace-product"] && !Shopify.designMode) return;
  try {
    
function initYogaSpace(root) {
  if (root.dataset.initialized) return;
  root.dataset.initialized = 'true';
  const reference = root.querySelector('.yp-reference');
  if (reference) {
    reference.querySelectorAll('[data-audience-choice]').forEach(button => button.addEventListener('click', () => {
      reference.dataset.audience = button.dataset.audienceChoice;
      reference.querySelectorAll('[data-audience-choice]').forEach(option => option.setAttribute('aria-pressed', String(option === button)));
    }));
  }
  const gallery = root.querySelector('[data-yp-gallery]');
  if (gallery) {
    const slides = Array.from(gallery.querySelectorAll('[data-yp-slide]'));
    const thumbs = Array.from(gallery.querySelectorAll('[data-yp-thumb]'));
    thumbs.forEach(button => button.addEventListener('click', () => {
      const selected = Number(button.dataset.ypThumb);
      slides.forEach((slide, index) => { slide.hidden = index !== selected; slide.classList.toggle('is-active', index === selected); });
      thumbs.forEach((thumb, index) => { thumb.classList.toggle('is-active', index === selected); thumb.setAttribute('aria-pressed', String(index === selected)); });
    }));
  }
  const form = root.querySelector('[data-yp-order]');
  const submit = root.querySelector('[data-yp-submit]');
  const radios = Array.from(root.querySelectorAll('.yp-plan-input'));
  function updatePlan(input, updateUrl) {
    if (!input) return;
    root.querySelector('[data-yp-name]').textContent = input.dataset.planName;
    root.querySelector('[data-yp-price]').textContent = input.dataset.planPrice;
    root.querySelector('[data-yp-button-name]').textContent = input.dataset.planName;
    submit.disabled = submit.dataset.closed === 'true' || input.dataset.planAvailable !== 'true';
    if (updateUrl) {
      const url = new URL(window.location.href);
      url.searchParams.set('variant', input.value);
      window.history.replaceState({}, '', url);
    }
  }
  radios.forEach(input => input.addEventListener('change', () => updatePlan(input, true)));
  const requested = new URLSearchParams(window.location.search).get('variant');
  const initial = radios.find(input => input.value === requested && !input.disabled) || radios.find(input => input.checked);
  if (initial) initial.checked = true;
  updatePlan(initial, false);
  form.addEventListener('submit', event => {
    if (submit.disabled || submit.dataset.closed === 'true') event.preventDefault();
  });
  const bar = root.querySelector('.yp-mobile-bar');
  const plans = root.querySelector('#yp-plans');
  if ('IntersectionObserver' in window) {
    const visibleTargets = new Set();
    const observer = new IntersectionObserver(entries => {
      entries.forEach(entry => { if (entry.isIntersecting) visibleTargets.add(entry.target); else visibleTargets.delete(entry.target); });
      bar.dataset.inPlans = String(visibleTargets.size > 0);
    }, { threshold: 0 });
    observer.observe(plans);
    const footer = document.querySelector('footer');
    if (footer) observer.observe(footer);
  }
}
document.querySelectorAll('[data-yogaspace-product]').forEach(initYogaSpace);
document.addEventListener('shopify:section:load', event => event.target.querySelectorAll('[data-yogaspace-product]').forEach(initYogaSpace));

  } catch(e) { console.error(e); }
})();
})();
